import { render, staticRenderFns } from "./badge-package-type.vue?vue&type=template&id=5c3a2795"
import script from "./badge-package-type.vue?vue&type=script&lang=js"
export * from "./badge-package-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports